import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import useSingleVacancyApplicationType from '../useSingleVacancyApplicationType';
import { getVacancyApplicationTypeViewSections } from '../vacancyApplicationTypeViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const Single = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { singleItem, loading } = useSingleVacancyApplicationType();

  const sections = useMemo(
    () => getVacancyApplicationTypeViewSections(t, singleItem),
    [t, singleItem],
  );

  const isSuccessUpdatePage = searchParams.get('success') === 'true';
  const listPath = UIHelper.getListRoute(pathname, 1);

  const pageTitle = isSuccessUpdatePage
    ? t('SETTORE WAS SUCCESSFULLY UPDATED.')
    : singleItem?.title || t('SETTORE');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`${pathname}/edit`}>{t('MODIFICA')}</Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={listPath}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Single;
